import { render, staticRenderFns } from "./SecretPassword.vue?vue&type=template&id=f4f13150&scoped=true&"
import script from "./SecretPassword.vue?vue&type=script&lang=ts&"
export * from "./SecretPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f13150",
  null
  
)

export default component.exports